import { react, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Image from 'mui-image';
import { Link } from 'react-router-dom';
import './Navbar.css'
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import MailIcon from '@mui/icons-material/Mail';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    customImageWrapper: {
        '& .mui-image-wrapper': {
            justifyContent: 'flex-start!important',
        },
    },
});

export default function Navbar(props) {
    const [dateState, setDateState] = useState(null); // used to force a rerender
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const classes = useStyles();

    const [navLink, setNavLink] = useState('Home');

    function navClicked(path) {
        if (path === 'Login') {
            //if (isTest()) {
            //    window.location = '/recycler/'
            //}
            //else {
            //    window.location = 'https://sipzee.com/returner/login.aspx'
            //}
            window.location = '/recycler/';
           
        }
        setNavLink(path);
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    function isTest() {
        if (window.location.href.indexOf('localhost') > -1) {
            return true;
        }
        else if (window.location.href.indexOf('test.sipzee.com') > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    function logout() {
        localStorage.removeItem('Customer');
        sessionStorage.clear();
        setDateState(new Date());
        setNavLink('Pickup');
      //  props.LoginChanged();
    }

    function getWebToken() {

        try {
            //  console.log('App: getWebToken');
            let webToken = JSON.parse(localStorage.getItem('Customer')).WebToken;
            //console.log(webToken);
            if (webToken === '') {
                console.log('Web Token was empty');
                return null;
            }
            else {
                return webToken;
            }
            //  return JSON.parse(localStorage.getItem('Login')).WebToken; // persists after window close
        }
        catch (e) {
            console.log('Navbar: error getting localStorage(Customer) ' + e);
        }

        console.log('getWebToken returning null');
        return null;
    }

    let isLoggedIn = getWebToken() != null;

    const createMenuList = (anchor) => (
      

        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem component={Link} key={'MenuLinkHome'} to='/Pickup' onClick={() => navClicked('Pickup')} className={navLink == 'Pickup' ? 'NavLinkSelected' : 'NavLink'}  disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Pickup my Cans'} />
                    </ListItemButton>
                </ListItem>
                
                <ListItem component={Link} key={'MenuLinkPortal'} to='/Portal' onClick={() => navClicked('Portal')} className={navLink == 'Portal' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                        <PersonIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Customer Portal'} />
                    </ListItemButton>
                </ListItem>
                
                {isLoggedIn ? null :
                    <ListItem component={Link} key={'MenuLinkAbout'} to='/About' onClick={() => navClicked('About')} className={navLink == 'About' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <InfoIcon />
                            </ListItemIcon>
                            <ListItemText primary={'About'} />
                        </ListItemButton>
                    </ListItem>
                }
                <ListItem component={Link} key={'MenuLinkContactUs'} to='/ContactUs' onClick={() => navClicked('ContactUs')} className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <MailIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Contact Us'} />
                    </ListItemButton>
                </ListItem>
                {isLoggedIn ? 
                    <>
                        <Divider />
                        <ListItem component={Link} key={'MenuLinkLogout'} to='' onClick={() => logout()} className={navLink == 'Logout' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <LogoutIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Logout'} />
                            </ListItemButton>
                        </ListItem>
                        </>
                    :
                    <>
                        <ListItem component={Link} key={'MenuLinkCharitySignUp'} to='/CharitySignup' onClick={() => navClicked('CharitySignup')} className={navLink == 'CharitySignup' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                            <ListItemButton>
                                <ListItemIcon className={classes.customImageWrapper}>
                                    <Image src='/images/DonateIcon.png' style={{ height: '24px', width:'24px' }} />
                                </ListItemIcon>
                                <ListItemText primary={'Charity/Fundraiser Signup'} />
                            </ListItemButton>
                        </ListItem>

                        <Divider />
                        <ListItem component={Link} key={'MenuLinkSignUp'} to='/SignUp' onClick={() => navClicked('SignUp')} className={navLink == 'SignUp' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <DirectionsCarIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Become a Driver'} />
                            </ListItemButton>
                        </ListItem>
                      
                        <ListItem key={'Menu-DriverLogin'} component={Link} to='' onClick={() => navClicked('Login')} disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <LoginIcon />
                                </ListItemIcon>
                                <ListItemText primary={'Driver Login'} />
                            </ListItemButton>
                        </ListItem>
                    </>
                }
            </List>
        </Box>
    );

    return (
        <div>
            <Drawer open={state['left']} onClose={toggleDrawer('left', false)} >
                {createMenuList('left')}
            </Drawer>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={toggleDrawer('left', true)}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>

                        
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            <Button
                                component={Link}
                                onClick={() => navClicked('Pickup')}
                                to='/Pickup'
                                key={'NavLinkPickup'}
                                sx={
                                    {
                                        my: 2,
                                        display: 'block'
                                    }
                                }
                                className={navLink == 'Pickup' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Pickup My Cans
                            </Button>
                            
                            <Button
                                component={Link}
                                onClick={() => navClicked('Portal')}
                                to='/Portal'
                                key={'NavLinkPortal'}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Portal' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Customer Portal
                            </Button>
                          
                            {isLoggedIn ? null :
                                <Button
                                    component={Link}
                                    onClick={() => navClicked('About')}
                                    to='/About'
                                    key={'NavLinkAbout'}
                                    sx={{ my: 2, display: 'block' }}
                                    className={navLink == 'About' ? 'NavLinkSelected' : 'NavLink'}
                                >
                                    About
                                </Button>
                            }
                            <Button
                                component={Link}
                                to='/ContactUs'
                                key={'NavLinkContactUs'}
                                onClick={() => navClicked('ContactUs')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'}
                            >Contact Us
                            </Button>
                            {isLoggedIn ? 
                                
                                <Button
                                    component={Link}
                                    to=''
                                    key={'NavLinkLogout'}
                                    onClick={() => logout()}
                                    sx={{ my: 2, display: 'block' }}
                                    className={navLink == 'Logout' ? 'NavLinkSelected' : 'NavLink'}
                                >
                                    Logout
                                </Button>
                                :
                                <>
                                   
                                    <Button
                                        component={Link}
                                        to='/CharitySignup'
                                        key={'CharitySignup'}
                                        onClick={() => navClicked('CharitySignup')}
                                        sx={{ my: 2, display: 'block' }}
                                        className={navLink == 'Login' ? 'NavLinkSelected' : 'NavLink'}
                                    >
                                        Charity & Fundraiser
                                    </Button>
                                    <Button
                                        component={Link}
                                        to='/SignUp'
                                        key={'NavLinkSignUp'}
                                        onClick={() => navClicked('SignUp')}
                                        sx={{ my: 2, display: 'block' }}
                                        className={navLink == 'SignUp' ? 'NavLinkSelected' : 'NavLink'}
                                    >
                                        Become a Driver
                                    </Button>
                                    <Button
                                        component={Link}
                                        to='/Login'
                                        key={'NavLinkLogin'}
                                        onClick={() => navClicked('Login')}
                                        sx={{ my: 2, display: 'block' }}
                                        className={navLink == 'Login' ? 'NavLinkSelected' : 'NavLink'}
                                    >
                                        Driver Login
                                    </Button>
                                </>
                            }
                            {/*<Button*/}
                            {/*    component={Link}*/}
                            {/*    to='/Order'*/}
                            {/*    key={'NavLinkOrder'}*/}
                            {/*    onClick={() => navClicked('Order')}*/}
                            {/*    sx={{ my: 2, display: 'block' }}*/}
                            {/*    className={navLink == 'Order' ? 'NavLinkSelected' : 'NavLink'}*/}
                            {/*>*/}
                            {/*    Order*/}
                            {/*</Button>*/}
                        </Box>
                        <Image src="/images/Sipzee white TM.png" width={128} height={50} />
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}
